// pages/ICoverTwoFactorPage.jsx
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../src/Context/AuthContext';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const ICoverTwoFactorPage = ({ portalSettings }) => {
    const [code, setCode] = useState('');
    const { login } = useAuth();
    const [searchParams] = useSearchParams();

    const token = searchParams.get('token');
    const redirectUri = searchParams.get('redirect_uri') || searchParams.get('redirect');

    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    useEffect(() => {
        document.title = `${companyName} - iCover Two Factor`;
    }, [companyName]);

    if (!portalSettings) return null;

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!token) {
            alert('Missing two factor token.');
            return;
        }

        if (!redirectUri) {
            alert('Missing iCover redirect URL.');
            return;
        }

        const res = await fetch(`${apiURL}/account/ICoverTwoFactor`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                code,
                token,
                redirectUri,
            }),
        });

        if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            alert(errorData.message || 'Login failed.');
            return;
        }

        const data = await res.json();
        const result = data.result;

        switch (result?.resultType) {
            case 0:
                login();

                if (result.redirectLink) {
                    window.location.assign(result.redirectLink);
                    return;
                }

                alert('Missing iCover redirect response.');
                break;

            case 3:
                alert('Server Error');
                break;

            case 4:
                alert('Invalid Two Factor Token');
                break;

            case 5:
                alert('Expired Two Factor Token');
                break;

            default:
                alert('Unexpected response from server.');
                break;
        }
    };

    return (
        <div className="auth-page">
            <EmptyHeader />
            <EmptyHeader />
            <EmptyHeader />
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">Two Factor</h2>

                <form className="baseForm" onSubmit={handleLogin}>
                    <label className="baseLabel">Two Factor Code</label>
                    <input
                        className="baseInput"
                        value={code}
                        onChange={(e) => setCode(e.target.value)}
                        required
                    />
                    <button className="baseButton" type="submit">Login</button>
                </form>
            </div>
        </div>
    );
};

export default ICoverTwoFactorPage;